import type { Router } from 'vue-router';
import { setRouteEmitter } from '@/utils/route-listener';
import setupUserLoginInfoGuard from './userLoginInfo';
import setupPermissionGuard from './permission';

function setupPageGuard(router: Router) {
  // 路由添加了权限校验，当有权限成功跳转后再设置上mitt
  router.afterEach(async (to, from, failure) => {
    // emit route change
    if (!failure) setRouteEmitter(to, from);
  });
}

export default function createRouteGuard(router: Router) {
  setupPageGuard(router);
  setupUserLoginInfoGuard(router);
  setupPermissionGuard(router);
}
